/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Button, ButtonGroup, Paper } from '@mui/material'
import { LocalGasStation, DoneAll } from '@mui/icons-material'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import * as organization from '../../../appRedux/actions/fuel_request/organization'
import ErrorBoundary from '../../../components/error_boundary'
import LoadingList from '../../../components/loading_list'
import IntlMessages from '../../../util/IntlMessages'
import EndRequest from './end_request'
import Refueling from './refueling'
import Content from './content'
import Head from './head'

function FuelRequestOrganizationInprocess(props) {
    const [refueling, setRefueling] = useState(false)
    const [endRequest, setEndRequest] = useState(false)
    let { id } = useParams()
    let vRequestCode = id.replace(':id', '')
    let details = props.list[0]

    useEffect(() => {
        requestDetailsFunc()
    }, [])

    const requestDetailsFunc = () => {
        props.fuelRequestOrganizationByRequestCodeAction(vRequestCode)
    }

    return (
        <React.Fragment>
            <ErrorBoundary>
                {props.loadingPage || props.list.length === 0 ? <LoadingList />
                    : <>
                        <Head />
                        <Paper style={{ paddingTop: 10, minHeight: 900, maxWidth: '100%' }}>
                            <Content {...details} />
                            <Grid style={{ paddingLeft: 10, paddingRight: 10 }}>
                                <ButtonGroup color="secondary" variant="contained" fullWidth>
                                    <Button
                                        onClick={() => setEndRequest(!refueling)}
                                        startIcon={<DoneAll />}>
                                        <IntlMessages id="endRequest" />
                                    </Button>
                                    <Button
                                        onClick={() => setRefueling(!refueling)}
                                        startIcon={<LocalGasStation />}>
                                        <IntlMessages id="recordLiterature" />
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Paper>
                        <Refueling
                            vRequestCode={vRequestCode}
                            refueling={refueling}
                            setRefuelingFunc={() => setRefueling(!refueling)}
                        />
                        <EndRequest
                            vRequestCode={vRequestCode}
                            endRequest={endRequest}
                            setEndRequestFunc={() => setEndRequest(!endRequest)}
                        />
                    </>}
            </ErrorBoundary>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        list: state.field.list,
        loadingPage: state.common.loadingPage
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fuelRequestOrganizationByRequestCodeAction: (code) => dispatch(organization.fuelRequestOrganizationByRequestCodeAction(code)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FuelRequestOrganizationInprocess)
